import script from "./NoteDocumenti.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteDocumenti.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__